import { captureException } from "@sentry/react";
import { type LoaderFunctionArgs, redirect } from "react-router";
import { AppConfig } from "src/configs/app-config";
import { APP_URL_PREFIX } from "src/configs/constants";
import { AppErrorState } from "src/router/app-error-state";
import appRoutes from "src/router/routes/app.router";
import type { RouterConfig } from "src/router/types";
import { convertFrameworkRoute } from "src/utils/routes";
import { canAccessToAccount, getDefaultUserAccountId } from "src/utils/user";

function appInitialLoader({ request }: LoaderFunctionArgs) {
	const url = new URL(request.url);
	const pathname = url.pathname;
	let newPathname = pathname;
	let prefix = AppConfig.getInstance().pageUrlPrefix;
	const config = AppConfig.getInstance().routerConfig as RouterConfig;

	if (!config) {
		captureException(new Error("No config found for initial loader"));
	}

	if (prefix === "") {
		const overrideAccountId = window.localStorage.getItem("pl-account-id");
		if (
			overrideAccountId &&
			canAccessToAccount(config.oidcUser, Number(overrideAccountId))
		) {
			prefix = `/${APP_URL_PREFIX}/${overrideAccountId}`;
		} else {
			const defaultAccountId = getDefaultUserAccountId(config.oidcUser);
			prefix = `/${APP_URL_PREFIX}/${defaultAccountId}`;
		}
	}

	if (
		pathname === "/" ||
		pathname === `/${APP_URL_PREFIX}` ||
		pathname === `/${APP_URL_PREFIX}/`
	) {
		newPathname = prefix;
	}

	if (!pathname.startsWith(`${prefix}`)) {
		newPathname = `${prefix}${pathname}`;
	}
	url.pathname = newPathname;
	return redirect(url.toString());
}

export default [
	{
		path: `/${APP_URL_PREFIX}/:accountId/*`,
		lazy: () =>
			import("src/router/MainComponent").then(convertFrameworkRoute),
		errorElement: <AppErrorState />,
		children: [
			{
				lazy: () =>
					import("src/layouts/AppLayout").then(convertFrameworkRoute),
				children: appRoutes,
				loader: ({ params: { accountId } }: LoaderFunctionArgs) => {
					if (accountId) {
						AppConfig.setPageUrlPrefix(accountId);
					}
				},
			},
		],
	},
	{
		path: "*",
		loader: (args: LoaderFunctionArgs) =>
			appInitialLoader({
				...args,
			}),
	},
];
